import { CSSProperties } from "react";

export const targetCustomStyles: CSSProperties | undefined = {
    position: 'absolute',
    backgroundColor: 'blue'
}

export const sourceCustomStyles: CSSProperties | undefined = {
    backgroundColor: 'yellow',
    position: 'absolute'
}